export const ListPermissionsRecargaCupoWithPasarela = Object.freeze({
  RECARGA_CUPO_CON_GOU: 700,
  RECARGA_CUPO_CON_EVERTEC: 800,
});
